import { render, staticRenderFns } from "./indentPice.vue?vue&type=template&id=1cf65648&scoped=true&"
import script from "./indentPice.vue?vue&type=script&lang=js&"
export * from "./indentPice.vue?vue&type=script&lang=js&"
import style0 from "./indentPice.vue?vue&type=style&index=0&id=1cf65648&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cf65648",
  null
  
)

export default component.exports